import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory, useLocation } from 'react-router';
import Grid from '@material-ui/core/Grid';
import { useSelector } from 'react-redux';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import PaymentTable from '../PaymentTable/PaymentTable';
import SearchBox from '../../../components/table/SearchBox';
import { CommonConfig } from '../../../config/common-config';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function SuperAdminPayments(props, row) {
    const history = useHistory();
    const location = useLocation();
    const [searchQuery, setSearchQuery] = useState('');
    const [rows, setTotalReactPackages] = useState([]);
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [handleGeneratedReceipt, setHandleGeneratedReceipt] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const username = JSON.parse(sessionStorage.getItem('user'));
    const { userType } = username.result.data;
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [openBox, setOpenBox] = useState(false);
    const vertical = 'top';
    const horizontal = 'center';
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const [selectedImc] = useState(location.state.domainname);


    const headcells = [
        // { id: 'intClientId', label: 'Client id' },
        { id: 'intClientName', label: 'IMC Name' },
        {
            id: 'invoiceId',
            label: 'Invoice Number',
            isConcat: 'true',
            concatElem: ['invoiceNumber'],
        },
        {
            id: 'invoiceId',
            label: 'Invoice Date',
            isConcat: '',
            concatElem: ['invoiceDate'],
        },
        { id: 'paymentAmount', label: 'Invoice amount' },
        {
            id: 'razorpayPaymentId',
            label: 'Reference Number',
        },
        {
            id: 'paymentDate',
            label: 'Amount Remitted On',
            date: 'true',
        },
        { id: 'comments', label: 'Comments by IMC' },
    ];

    function formatDate(props) {
        return props.map((element) => {
            // const tempEndDate = element.dateModified;
            const tempPaymentDate = element.paymentDate;
            // element.dateModified = tempEndDate.split(' ', 1);
            element.paymentDate = tempPaymentDate.split(' ', 1);
        });
    }

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    useEffect(() => {
        if (searchQuery && searchQuery.length > 2) {
            getSearchValue(searchQuery);
        } else {
            setSearchData([]);
            getTotalPackages();
        }
    }, [handleGeneratedReceipt, userToken, selectedImc, page]);

    const getTotalPackages = () => {
        if (userType === 'SUPERADMIN') {
            axios
                .get(`${CommonConfig.dev.baseUrl}/api/auth/payment-history-int-clients/${selectedImc}?page=${page}&size=10&sort=paymentDate,desc`, {
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    formatDate(response.data.content);
                    setTotalReactPackages(response.data.content);
                    setPageDetails(response.data);
                    setLoading(false);
                    if (response.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (response.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                })

                .catch(() => {
                    // console.log("error", error.response);
                });
        }
    };

    const getSearchValue = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/payment-history-int-clients/${selectedImc}?search=${data}&page=${page}&size=10&sort=paymentDate,desc`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((res) => {
                // console.log('responseresponse11', res);
                if (res.data) {
                    if (res.data.content.length === 0) {
                        setTotalReactPackages([]);
                    }
                    formatDate(res.data.content);
                    setSearchData(res.data.content);
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })

            .catch((error) => { });
    };

    const handleGenerateReceipt = (data) => {
        // console.log('data', data);

        // setShowBtnLoader(true);

        if (data.paymentId) {
            axios

                .post(`${CommonConfig.dev.baseUrl}/api/auth/generate-receipt/${data.paymentId}`, '', {
                    headers: {
                        Authorization: bearerToken,
                    },
                })

                .then((response) => {
                    // formatDate(response.data.content);

                    if (response.data === 'SUCCESS') {
                        setHandleGeneratedReceipt(true);

                        setShowBtnLoader(false);
                    }
                })

                .catch((error) => {
                    const errResult = error.response;

                    if (errResult.data) {
                        setErrorMsgGenerateRecceipt(errResult.data.message);

                        setShowBtnLoader(false);

                        setOpenBox(true);
                    }
                });
        }
    };

    // search Query

    const handleSearchQuery = (searchData) => {
        setSearchQuery(searchData);

        if (searchData && searchData.length > 2) {
            getSearchValue(searchData);

            return true;
        }

        if (!searchData) {
            setSearchData([]);

            // setPage(0);

            getTotalPackages();
        }
    };

    const handleClose = () => {
        setOpenBox(false);

        setShowBtnLoader(false);
    };

    const clearField = () => {
        setSearchQuery('');

        setSearchData([]);

        // setPage(0);

        getTotalPackages();
    };

    const filteredRow = searchData && searchData.length ? searchData : rows;
    const classes = useStyles();

    const back = () => {
        history.push({
            pathname: '/menu/superadminpayments',
        });
    };

    return (
        <>
            <Snackbar
                className="deleteError"
                open={openBox}
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={5000}
                onClose={handleClose}
            >
                <Alert onClose={handleClose} severity="error">
                    {errorMsgGenerateRecceipt}
                </Alert>
            </Snackbar>

            {(showBtnLoader ? (
                <LoaderPopUp
                    showLoader={showBtnLoader}
                    handleClose={handleClose}
                    title=" Please wait while the receipt is being generated"
                />
            ) : // <div style={{ position: 'relative', top: 300, left: 700 }}>

                //     <span style={{ position: 'absolute', top: 20 }}>Loading......</span>

                //     <CircularProgress style={{ color: '#F8951B' }} size={20} />

                // </div>

                null) || (
                    <Card className="custom-table mb10">
                        <CardContent className="card-title-display">
                            <Grid item xs={12} sm={8}>
                                <Typography className="card-title">Payment History</Typography>
                            </Grid>

                            <Grid item xs={12} sm={6} className="card-search">
                                <div className="search-field">
                                    <SearchBox
                                        searchQuery={searchQuery}
                                        onChange={handleSearchQuery}
                                        clearField={clearField}
                                        placeholder="Search..."
                                    />
                                </div>
                            </Grid>
                        </CardContent>

                        <CardContent className="card-table-display">
                            {rows && filteredRow.length > 0 ? (
                                <>
                                    <PaymentTable
                                        headcells={headcells}
                                        rows={filteredRow}
                                        handleGenerateReceipt={handleGenerateReceipt}
                                        pageName="superAdmin"
                                        action
                                        attachment
                                        handleCount={handleCount}
                                        pageDetails={pageDetails}
                                        loading={loading}
                                        prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                    />
                                </>
                            ) : (
                                    <div className={classes.noRecord}>
                                        <h1>No records to display</h1>
                                    </div>
                                )}
                        </CardContent>
                    </Card>
                )}
            <Button variant="contained" onClick={() => back()} className="btnBlue txt-cap btnBckFloat" color="primary">
                Back
                </Button>
        </>
    );
}

export default SuperAdminPayments;
